import firebase from './firebaseBundle'

const sendVerificationEmail = async (redirectURL) => {
  const firebaseJWT = await firebase.auth().currentUser.getIdToken(false)

  const urlWithOutgoingParams = new URL(redirectURL)
  urlWithOutgoingParams.searchParams.append('access_token', firebaseJWT)

  if (window.analytics.user) {
    const segmentAnonymousID = window.analytics.user().anonymousId()
    urlWithOutgoingParams.searchParams.append(
      'segment_anonymous_id',
      segmentAnonymousID
    )
  }

  const urlScheme = urlWithOutgoingParams.protocol
  // handle deep links
  if (urlScheme !== 'http:' && urlScheme !== 'https:') {
    urlWithOutgoingParams.searchParams.append(
      'custom_scheme_redirect_uri',
      urlWithOutgoingParams.href
    )
    urlWithOutgoingParams.searchParams.delete('access_token')
    urlWithOutgoingParams.protocol = 'https:'
    urlWithOutgoingParams.host = 'anovaculinary.com'
  }

  await firebase
    .auth()
    .currentUser.sendEmailVerification({ url: urlWithOutgoingParams.href })
}

export default sendVerificationEmail
